/* global globalThis, G */
import { type Plugin } from 'platform/adapter/plugin/api'

const INIT_KEY = 'yzgl9rmyge'

/**
 * Abstracts the handling of the Userlane script and makes its usage completely optional.
 *
 * {@see https://docs.userlane.com/docs/api-quick-reference}
 */
const userlane = (obj: Gaia.Mobile.Application): Plugin => Object.create({}, {
  init: {
    /**
     * Runs the Userlane initialization snippet.
     */
    value: async () => new Promise((resolve: (value?: any) => void, reject) => {
      if (!globalThis.UserlaneCommandObject) {
        globalThis.UserlaneCommandObject = 'Userlane'

        globalThis.Userlane = globalThis.Userlane || ((...args) => {
          (globalThis.Userlane.q = globalThis.Userlane.q || []).push(...args)
        })

        const script = document.createElement('script')
        const documentScript = document.getElementsByTagName('script')[0]

        script.async = true
        script.src = 'https://cdn.userlane.com/userlane.js'
        script.id = 'userlane-script'
        script.onload = resolve
        script.onerror = reject
        documentScript.parentNode?.insertBefore(script, documentScript)
      } else {
        resolve()
      }
    }),
    enumerable: true,
  },
  onLogin: {
    /**
     * Runs the Userlane identify and init commands.
     */
    value: () => {
      const session = obj[G.SESSION][G.STATE][G.META]
      const [user] = session.refs.user
      // Identify user
      globalThis.Userlane('identify', user.value.name)
      // Initialize library
      globalThis.Userlane('init', INIT_KEY)
    },
    enumerable: true,
  },
  onLogout: {
    /**
     * Runs the Userlane hide command.
     */
    value: () => {
      globalThis.Userlane('hide')
    },
    enumerable: true,
  },
  destroy: {
    /**
     * Removes the objects created by the init method.
     */
    value: async () => {
      if (globalThis.UserlaneCommandObject) {
        globalThis.Userlane('hide')
        const script = document.getElementById('userlane-script')
        script?.remove()

        delete globalThis.UserlaneCommandObject
        delete globalThis.Userlane
      }
    },
    enumerable: true,
  },
})

export default userlane
